import { render, staticRenderFns } from "./class_card.vue?vue&type=template&id=c61cd93e&scoped=true&"
import script from "./class_card.vue?vue&type=script&lang=js&"
export * from "./class_card.vue?vue&type=script&lang=js&"
import style0 from "./class_card.vue?vue&type=style&index=0&id=c61cd93e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61cd93e",
  null
  
)

export default component.exports